import type { KeyboardEvent } from "react";

export const isEnterKey = (event: KeyboardEvent): boolean => {
  return event.key === "Enter";
};

export const isShiftEnterCommand = (event: KeyboardEvent): boolean => {
  return isEnterKey(event) && event.shiftKey;
};

export const isNavigationConfirmKey = (event: KeyboardEvent): boolean => {
  return ["Enter", " "].includes(event.key);
};
